import React from 'react'

export type TooltipPosition = 'top-center' | 'top-right' | 'bottom-center'

export function Tooltip({
  children,
  tooltip,
  position = 'top-center',
}: {
  children: React.ReactNode
  tooltip?: string
  position?: TooltipPosition
}) {
  const positionClass = `pc-icon-button__tooltip--${position}`

  return (
    <div className="relative group/pc-icon-button flex flex-col items-center">
      {children}

      {tooltip && (
        <div
          className={`pc-icon-button__tooltip ${positionClass} transition transition-opacity delay-500 opacity-0 z-30`}
        >
          <span className="pc-icon-button__tooltip__text rounded-lg">{tooltip}</span>
          <div className="pc-icon-button__tooltip__arrow"></div>
        </div>
      )}
    </div>
  )
}
